import { render } from "./Chanpin1.vue?vue&type=template&id=e952f870&scoped=true"
import script from "./Chanpin1.vue?vue&type=script&lang=js"
export * from "./Chanpin1.vue?vue&type=script&lang=js"

import "./Chanpin1.vue?vue&type=style&index=0&id=e952f870&scoped=true&lang=css"

import exportComponent from "D:\\lxq\\nkpcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e952f870"]])

export default __exports__